<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_managetransferrole/_update/updateHistory.vue'
export default {
  components: {
    createContent
  }
}
</script>
